import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type BuildingIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const BuildingIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: BuildingIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99663 3.99658H14.0008C14.5533 3.99658 15.0012 4.44448 15.0012 4.997V20.0032H3.99663C3.44412 20.0032 2.99622 19.5553 2.99622 19.0028V4.997C2.99622 4.44448 3.44412 3.99658 3.99663 3.99658Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0012 7.99854H20.0033C20.5558 7.99854 21.0037 8.44644 21.0037 8.99895V19.0031C21.0037 19.5556 20.5558 20.0035 20.0033 20.0035H15.0012V7.99854Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99789 7.8732C6.92882 7.8732 6.87284 7.92919 6.87284 7.99826C6.87284 8.06732 6.92882 8.12331 6.99789 8.12331C7.06695 8.12331 7.12294 8.06732 7.12294 7.99826C7.12294 7.92919 7.06695 7.8732 6.99789 7.8732"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9996 7.8732C10.9305 7.8732 10.8745 7.92919 10.8745 7.99826C10.8745 8.06732 10.9305 8.12331 10.9996 8.12331C11.0687 8.12331 11.1247 8.06732 11.1247 7.99826C11.1247 7.92919 11.0687 7.8732 10.9996 7.8732"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99789 11.8752C6.92882 11.8752 6.87284 11.9311 6.87284 12.0002C6.87284 12.0693 6.92882 12.1253 6.99789 12.1253C7.06695 12.1253 7.12294 12.0693 7.12294 12.0002C7.12294 11.9311 7.06695 11.8752 6.99789 11.8752"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9996 11.8752C10.9305 11.8752 10.8745 11.9311 10.8745 12.0002C10.8745 12.0693 10.9305 12.1253 10.9996 12.1253C11.0687 12.1253 11.1247 12.0693 11.1247 12.0002C11.1247 11.9311 11.0687 11.8752 10.9996 11.8752"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99789 15.8766C6.92882 15.8766 6.87284 15.9326 6.87284 16.0017C6.87284 16.0707 6.92882 16.1267 6.99789 16.1267C7.06695 16.1267 7.12294 16.0707 7.12294 16.0017C7.12294 15.9326 7.06695 15.8766 6.99789 15.8766"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9996 15.8766C10.9305 15.8766 10.8745 15.9326 10.8745 16.0017C10.8745 16.0707 10.9305 16.1267 10.9996 16.1267C11.0687 16.1267 11.1247 16.0707 11.1247 16.0017C11.1247 15.9326 11.0687 15.8766 10.9996 15.8766"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0025 11.8752C17.9334 11.8752 17.8774 11.9311 17.8774 12.0002C17.8774 12.0693 17.9334 12.1253 18.0025 12.1253C18.0715 12.1253 18.1275 12.0693 18.1275 12.0002C18.1275 11.9311 18.0715 11.8752 18.0025 11.8752"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0025 15.8766C17.9334 15.8766 17.8774 15.9326 17.8774 16.0017C17.8774 16.0707 17.9334 16.1267 18.0025 16.1267C18.0715 16.1267 18.1275 16.0707 18.1275 16.0017C18.1275 15.9326 18.0715 15.8766 18.0025 15.8766"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
